import { doc, setDoc, onSnapshot, collection, query, where, updateDoc, getDoc, arrayUnion } from "firebase/firestore";
import { db } from "../../firebase"
import Swal from 'sweetalert2'
import moment from 'moment'

const GetQuizz = () =>
  async (dispatch) => {
    const q = collection(db, "Quiz");
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const QuizList = [];
      querySnapshot.forEach((doc) => {
        QuizList.push(doc.data());
      });
      dispatch({ type: 'GetQuizz', payload: QuizList })
    });
  }


const GetEssay = () =>
  async (dispatch) => {
    const q = collection(db, "EassayExam");
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const EssayList = [];
      querySnapshot.forEach((doc) => {
        EssayList.push(doc.data());
      });
      dispatch({ type: 'GetEssay', payload: EssayList })

    })
  }

const GetAnnoucements = () =>
  async (dispatch) => {
    const q = collection(db, "Annoucements");
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const Annoucements = [];
      querySnapshot.forEach((doc) => {
        Annoucements.push({ ...doc.data(),uid:doc?.id })
      });
      dispatch({ type: 'GetAnnoucements', payload: Annoucements })
    });
  }



const GetQuestion = (fundata) =>
  async (dispatch) => {
    const q = collection(db, "QuizQuestion", fundata.quizdetailid == undefined ? fundata.quizid : fundata.quizdetailid, "Question");
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const Questions = [];
      querySnapshot.forEach((doc) => {
        console.log('DocID==>', doc.id)
        Questions.push({ ...doc.data(), QuestionId: doc.id })
      });
      dispatch({ type: 'QuizQuestion', payload: Questions?.sort()?.reverse() })

    })

  }


const StartEssayExam = (user, ExamData, navigation) =>

  async (dispatch) => {
    const unsub = await onSnapshot(doc(db, "EssayExamCheck", ExamData.essayid, "Essay", user.uid), (docE) => {

      if (docE.exists() == false) {
        setDoc(doc(db, "EssayExamCheck", ExamData.essayid, "Essay", user.uid), {
          essayid: ExamData.essayid,
          uid: user.uid,
          essaytext: '',
          starttime: new Date(),
          finishtime: '',
          fininshEssay: false,
        })

        // setDoc(doc(db, "UserAssginEssayIds", user.uid,), {
        //   IDS: arrayUnion(ExamData.essayid)
        // })

      }
    })
  }


const FinishExam = (user, ExamData, navigation, EassyText, UsedTimeByUser) =>
  async (dispatch) => {
    const markessay = doc(db, "EssayExamCheck", ExamData.essayid, "Essay", user.uid);
    await updateDoc(markessay, {
      essaytext: EassyText,
      finishtime: new Date(),
      fininshEssay: true,
      TotalUsedTime: UsedTimeByUser
    }).then(() => {
      Swal.fire({
        title: "Best Of Luck",
        text: "Successfully Submitted",
        icon: "success",
        button: "Ok",
      })
      navigation(-1)
    })

  }

const DraftEssayExa = (user, ExamData, navigation, EassyText, UsedTimeByUser) =>
  async (dispatch) => {
    const markessay = doc(db, "EssayExamCheck", ExamData.essayid, "Essay", user.uid);
    await updateDoc(markessay, {
      essaytext: EassyText,
      TotalUsedTime: UsedTimeByUser
    }).then(() => {
      Swal.fire({
        title: "Saved Draft",
        text: "Please try to finish as soon as possible",
        icon: "success",
        button: "Ok",
      })
      navigation(-1)
      window.location.reload()
      // window.location.reload()
    })
  }





const isAlreadyEssay = (customization, User, setlaoding) =>
  async dispatch => {
    let tempDoc = [];
    let ContinueExamArray = []

    Object.keys(customization?.Essay).map(async (value, index) => {

      const docRef = doc(db, "EssayExamCheck", customization?.Essay[value]?.essayid, "Essay", User.uid);
      const docSnap = await getDoc(docRef);



      if (docSnap.exists()) {
        tempDoc.push(docSnap.data().essayid)
        dispatch({ type: 'AlredyQuiz', payload: tempDoc });
      }

      if (docSnap.data()?.fininshEssay == false) {
        ContinueExamArray.push(true)
      } else {
        ContinueExamArray.push(false)
      }

      dispatch({ type: 'EssayExamContinue', payload: ContinueExamArray });
      console.log('docSnap.data()===>', ContinueExamArray)
      setTimeout(() => {
        setlaoding(false)
      }, 3000)


    })
    setTimeout(() => {
      setlaoding(false)
    }, 3000)
  }


const isAlreadyQuizz = (customization, User, setlaoding) =>
  async dispatch => {

    let tempDoc = [];
    let ContinueQuiz = [];

    Object.keys(customization?.Quizz).map(async (value, index) => {
      const docRef = doc(db, "QuizCheck", customization?.Quizz[value]?.quizdetailid, "QuizAnswer", User.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        tempDoc.push(docSnap.data().quizid)
        dispatch({ type: 'isAlreadyQuizz', payload: tempDoc })
      }

      if (docSnap.data()?.finishexam == false) {
        ContinueQuiz.push(true)
      } else {
        ContinueQuiz.push(false)
      }

      dispatch({ type: 'QuizExamContinue', payload: ContinueQuiz });

      setTimeout(() => {
        setlaoding(false)
      }, 3000)
    })

    setTimeout(() => {
      setlaoding(false)
    }, 3000)
  }



const QuizExamStart = (user, ExamData, navigation) =>

  async (dispatch) => {
    const unsub = await onSnapshot(doc(db, "QuizCheck", ExamData.quizdetailid, "QuizAnswer", user.uid), (docE) => {
      if (docE.exists() == false) {
        setDoc(doc(db, "QuizCheck", ExamData.quizdetailid, "QuizAnswer", user.uid), {
          quizid: ExamData.quizdetailid,
          uid: user.uid,
          starttime: new Date(),
          finishtime: '',
          finishexam: false,
        })
      }
    })
  }



const QuizExamFinish = (user, ExamData, navigation, score, selectedanswe, startTime, UsedTimeByUser) =>
  async (dispatch) => {
    var a = startTime
    var b = new Date();
    var difference = (b - a) / 1000;
    const markessay = doc(db, "QuizCheck", ExamData.quizdetailid, "QuizAnswer", user.uid);
    await updateDoc(markessay, {
      finishtime: new Date(),
      finishexam: true,
      totacorrectanswer: score,
      // correctanswer: selectedanswe,
      TotalUsedTime: UsedTimeByUser
    }).then(() => {
      navigation(-1)
    })
  }



const GetAllQuizzWiiner = (data) =>
  async (dispatch) => {

    const q = collection(db, "QuizzWinners");
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const QuizList = [];
      querySnapshot.forEach((doc) => {
        QuizList.push(doc.data());
      });
      const sortedActivities = QuizList?.sort((a, b) => b.createrdatetime - a.createrdatetime)

      dispatch({ type: 'QuizzWinners', payload: sortedActivities })

    })

  }

const GetAllEssayWinner = (data) =>
  async (dispatch) => {
    const q = collection(db, "EassayWinners");
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const EssayList = [];
      querySnapshot.forEach((doc) => {
        EssayList.push(doc.data());
      });

      const sortedActivities = EssayList?.sort((a, b) => b.createrdatetime - a.createrdatetime)

      console.log('querySnapshot', querySnapshot)
      dispatch({ type: 'GetAllEssayWinner', payload: sortedActivities })

    })
  }


const updateprofilr = (username, gender, Setvisible, user, enqueueSnackbar) =>
  async (dispatch) => {



    // var days = 4749;
    // var newdate = new Date(Date.now() - days * 24 * 60 * 60 * 1000)
    // const d = new Date(newdate);
    // const formatdate = moment(d).format('YYYY-MM-DD');
    // const event1 = moment(DOBS).format('YYYY-MM-DD');
    // var check = moment(event1).isAfter(formatdate)




    // if (check == true) {

    //   enqueueSnackbar('You must be 13 years old', { variant: 'error', });

    // }
    // else {




    // const event = moment(DOBS).format('YYYY-MM-DD');

    if (username != "" && username != undefined && gender != "" && gender != "") {


      const markessay = doc(db, "Users", user.uid);

      await updateDoc(markessay, {
        name: username,
        lastupdated: new Date().toDateString(),
        // dob: event,
        gender: gender
      }).then(() => {

        Setvisible(false)
        Swal.fire({
          title: "Successfully Updated",
          text: " Submitted",
          icon: "success",
          button: "Ok",
        })
      })
    }
    else {
      Swal.fire({
        title: "Failed To Update",
        icon: "error",
        button: "Try Again",
      })
    }


  }

const formadmin = (pname, pcon, pemail, paddress, Setvisible2, user, enqueueSnackbar) =>
  async (dispatch) => {


    const emailValidation = () => {
      const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (!pemail || regex.test(pemail) === false) {

        return false;
      }
      return true;
    }



    if (emailValidation() != true) {
      enqueueSnackbar('Email Invalid', { variant: 'error', });
    } else {
      if (pname != undefined && pcon != undefined && pemail != undefined && paddress != undefined &&

        pname != "" && pcon != "" && pemail != "" && paddress != "") {

        const markessay = doc(db, "Users", user.uid);
        await updateDoc(markessay, {
          pname,
          pcon,
          pemail,
          paddress,
          lastupdated: new Date().toDateString(),
          ConsultantForm: true


        }).then(() => {

          Setvisible2(false)
          enqueueSnackbar('Successfully Update', { variant: 'success', });
        })
      }
      else {
        enqueueSnackbar('Fill all fields', { variant: 'error', });
      }
    }






  }

const formadmin2 = (DOBS, gender, user, enqueueSnackbar) =>
  async (dispatch) => {







    if (DOBS != undefined && gender != undefined && DOBS != "" && gender != "") {

      var days = 4749;
      var newdate = new Date(Date.now() - days * 24 * 60 * 60 * 1000)
      const d = new Date(newdate);
      const formatdate = moment(d).format('YYYY-MM-DD');
      const event1 = moment(DOBS).format('YYYY-MM-DD');
      var check = moment(event1).isAfter(formatdate)




      if (check == true) {

        enqueueSnackbar('You must be 13 years old', { variant: 'error', });

      }

      else {



        const age1 = moment(DOBS).format('YYYY-MM-DD')


        const markessay = doc(db, "Users", user.uid);
        await updateDoc(markessay, {
          dob: age1,
          gender: gender,
          lastupdated: new Date().toDateString(),
        }).then(() => {


          Swal.fire({
            title: "Successfully",
            text: "Updated",
            icon: "success",
            button: "Ok",
          })
        })
      }
    }


  }


export {

  GetQuizz,
  GetEssay,
  GetQuestion,
  StartEssayExam,
  FinishExam,
  QuizExamStart,
  QuizExamFinish,
  GetAllQuizzWiiner,
  GetAllEssayWinner,
  isAlreadyQuizz,
  isAlreadyEssay,
  updateprofilr,
  formadmin,
  formadmin2,
  GetAnnoucements,
  DraftEssayExa,

}

